import React from 'react';
import { observer } from 'mobx-react';
import { Box } from 'components';
import { PriceBreakdown } from 'apps/shared';
import { clientStore } from 'apps/client/app';

interface PriceBreakdownProps {
  order: any;
}

export const OrderPriceBreakdown = observer(
  ({ order }: PriceBreakdownProps) => {
    const { quote } = order;

    const isIntermediatorMode = clientStore.currentPortal === 'INTERMEDIATOR';
    let takeRate = null;
    let takeRateAmount = 0;
    let productionCosts = quote.customerProductionCosts;
    if (isIntermediatorMode) {
      ({ takeRate, productionCosts, takeRateAmount } = quote);
    }

    const payment = order.payments[0];

    const vatCountry =
      payment.billingAddress?.country || order.quote.address.country;

    const totalPaid = order.payments.reduce(
      (acc: number, p: any) => acc + p.amount,
      0,
    );
    const { tax: vatAmount } = payment;
    const vatPerCent =
      (100 * vatAmount) / (totalPaid - order.quote.shippingQuote.cost);

    return (
      <Box>
        <PriceBreakdown
          currency={quote.productQuoteCurrency}
          productionCosts={productionCosts}
          shippingCosts={quote.shippingQuote.cost}
          shippingDiscount={quote.shippingQuote.discount}
          miscItemsTotalCost={quote.miscItemsTotalCost}
          takeRate={takeRate}
          takeRateAmount={takeRateAmount}
          totalCost={quote.totalCost}
          vatAmount={vatAmount}
          vatPerCent={vatPerCent}
          vatCountry={vatCountry}
        />
      </Box>
    );
  },
);
